import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stock-indicator-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_indicator = _resolveComponent("indicator")!

  return (_ctx.materialItem.sparePartStatus)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_ctx.isHidden)
          ? (_openBlock(), _createBlock(_component_indicator, {
              key: 0,
              text: _ctx.localize('hidden').toUpperCase(),
              class: "indicator-only-visible-for-admins",
              clickable: false
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(_component_indicator, {
          text: _ctx.indicatorText.toUpperCase(),
          class: _normalizeClass(_ctx.indicatorClass),
          clickable: false,
          title: _ctx.tooltip
        }, null, 8, ["text", "class", "title"])
      ]))
    : _createCommentVNode("", true)
}